const getOrderStatusLabel = (orderStatus, intl) => {
  return orderStatus ? intl.getLabel(`account.order.orderState.${orderStatus.key}`) : void 0;
};
export {
  getOrderStatusLabel
};
//# sourceMappingURL=get-order-status-label.js.map
